var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"color":"#C4C4C4","size":"31"}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("mdi-account")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }